import { useMemo } from 'react';
import { Outlet } from 'react-router';

import SpinLoading from '@/components/general/SpinLoading';
import { PRODUCT_CATALOG_URLS } from '@/constants/urls';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { useInitialLoading } from '@/hooks/useInitialLoading';
import { useSelectScrollSearch } from '@/hooks/useSelectScrollSearch';

const ProductCatalogSection = () => {
  useDocumentTitle({
    resourceTitle: 'Catálogo de Productos',
    showTitle: 'Producto {id}',
    editTitle: 'Editar producto {id}',
    createTitle: 'Nuevo producto',
  });

  const { selectProps: productCategorySelectProps } = useSelectScrollSearch({
    resource: PRODUCT_CATALOG_URLS.PRODUCT_CATEGORIES,
    optionLabel: (item: any) => item.name,
  });
  const isLoading = useMemo(
    () => productCategorySelectProps.loading,
    [productCategorySelectProps.loading],
  );
  const { initialLoading } = useInitialLoading(isLoading);

  return (
    <div className="ProductCatalogSection MainSection">
      {initialLoading ? <SpinLoading /> : <Outlet context={{ productCategorySelectProps }} />}
    </div>
  );
};

export default ProductCatalogSection;
